(() => {
  'use strict';

  const locale = String(window.DevidLocaleGuardConfig?.locale || document.documentElement.lang || 'it').toLowerCase();
  const isEnglish = locale.startsWith('en');

  // This compatibility layer only contains English replacements. Avoid building
  // dictionaries and attaching a global observer on the primary Italian store.
  if (!isEnglish) return;

  const english = new Map([
    ['Ordina entro le 14:00: spedizione oggi', 'Order by 2:00 PM: ships today'],
    ['Ordina ora: spedizione domani', 'Order now: ships tomorrow'],
    ['Ordina ora: spedizione lunedì', 'Order now: ships Monday'],
    ['Descrizione', 'Description'],
    ['Aggiungi al carrello', 'Add to cart'],
    ['Pre-ordina', 'Pre-order'],
    ['Esaurito', 'Sold out'],
    ['Scegli le opzioni', 'Choose options'],
    ['Visualizza dettagli', 'View details'],
    ['Prodotto aggiunto!', 'Added to your cart!'],
    ['Prodotto aggiunto !', 'Added to your cart!'],
    ['In sconto', 'On sale'],
    ['Tabella taglie', 'Size guide'],
    ['Scegli il colore', 'Choose a color'],
    ['Recensioni Google e garanzie Devid Label', 'Google reviews and Devid Label guarantees'],
    ['oltre 1.200 recensioni', 'over 1,200 reviews'],
    ['Prodotto esclusivo', 'Exclusive product'],
    ['Design Devid Label', 'Devid Label design'],
    ['Rivenditore autorizzato', 'Authorized retailer'],
    ['Originali 100%', '100% original'],
    ['InPost gratis', 'Free InPost'],
    ['Servizi inclusi dopo l’acquisto', 'Services included after purchase'],
    ['Spedizione InPost sempre gratis', 'Free InPost delivery'],
    ['Reso facile entro 14 giorni', 'Easy returns within 14 days'],
    ['Spedizioni lun-ven entro le 14:00', 'Mon–Fri shipping by 2:00 PM'],
    ['Spedizione gratuita', 'Free shipping'],
    ['Scopri la collection', 'Shop the collection'],
    ['Returns Policypage', 'Returns Policy']
  ]);

  function translate(root) {
    if (!root) return;
    const scope = root.closest?.('.shopify-section--main-product, product-sticky-bar') || root.querySelector?.('.shopify-section--main-product, product-sticky-bar') || null;
    if (!scope) return;

    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement?.closest('script, style, textarea, input, option')
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    });

    let node;
    while ((node = walker.nextNode())) {
      const original = node.nodeValue;
      const trimmed = original.trim();
      let translated = english.get(trimmed);
      if (!translated && /^o in 3 rate da\b/i.test(trimmed)) {
        translated = trimmed.replace(/^o in 3 rate da\b/i, 'or in 3 instalments of');
      }
      if (!translated || translated === trimmed) continue;
      node.nodeValue = `${original.match(/^\s*/)?.[0] || ''}${translated}${original.match(/\s*$/)?.[0] || ''}`;
    }
  }

  translate(document);

  let scheduled = false;
  const observer = new MutationObserver((mutations) => {
    if (scheduled) return;
    const target = mutations.find((mutation) => mutation.target?.nodeType === Node.ELEMENT_NODE)?.target || document;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      translate(target);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
